import { Component, OnInit } from '@angular/core';
import { NbThemeService } from '@nebular/theme';

@Component({
    selector: 'app-wtn-cta',
    templateUrl: './wtn-cta.component.html',
    styleUrls: ['./wtn-cta.component.scss'],
})
export class WtnCtaComponent implements OnInit {
    buttonSize = 'medium';
    constructor(public themeService: NbThemeService) {
        this.themeService.onMediaQueryChange().subscribe(([_, currentBreakpoint]) => {
            if (currentBreakpoint.width < 768) {
                this.buttonSize = 'small';
            } else {
                this.buttonSize = 'medium';
            }
        });
    }

    ngOnInit(): void {}
}
